export const mockBannerPaper = {
  message: '30% off all invites & thank yous with code NEW30 ends 05/01',
  color: '#fff',
  backgroundColor: '#005759',
  cta: 'Shop now',
  ctaLink: '/shop/collection/top-registry-gifts-this-week',
  label: 'Sale',
};

export const mockBannerBudget = {
  message: 'Introducing the Budget Planner: Plan your dream wedding with ease on Zola!',
  color: '#77133F',
  backgroundColor: '#F3F3F3',
  cta: 'Get started',
  ctaLink: '/wedding/manage/budget',
  label: 'New',
};

export const mockBannerHoliday = {
  message:
    'Holiday cards are very extra ultra mega awesome.  Get 50% off site-wide cards with code HOLIDAY50 ends 05/01. Details',
  color: '#fff',
  backgroundColor: '#77133F',
  cta: 'Shop now',
  label: 'Sale',
  ctaLink: '/wedding-planning/holiday-cards/shop',
};

export const mockBanners = [mockBannerPaper, mockBannerBudget, mockBannerHoliday];
